(function () {
  function escapeHtml(value) {
    return String(value == null ? "" : value)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }

  function normalizeFrameNumber(value) {
    return String(value || "").trim().toUpperCase().replace(/[\s-]+/g, "");
  }

  function isCortinaFrameNumber(value) {
    return /^CO[0-9]{6,12}$/.test(value) || /^C[A-Z0-9]{5,15}$/.test(value);
  }

  function brand(root) {
    return String(setting(root, "brand", "cortina") || "cortina").toLowerCase();
  }

  function isBatavusFrameNumber(value) {
    return /^[A-Z]{2}[0-9]{7}$/.test(value) || /^BA[A-Z0-9]{6,20}$/.test(value);
  }

  function isFrameNumber(root, value) {
    return brand(root) === "batavus" ? isBatavusFrameNumber(value) : isCortinaFrameNumber(value);
  }

  function setting(root, name, fallback) {
    var value = root.getAttribute("data-" + name);
    if (value == null || value === "") return fallback;
    return value;
  }

  function enabled(root, name, fallback) {
    var value = root.getAttribute("data-" + name);
    if (value == null || value === "") return fallback;
    return !/^(0|false|nee|no)$/i.test(String(value));
  }

  function cortinaFormatMessage(root) {
    var fallback =
      brand(root) === "batavus"
        ? "Vul een geldig fietsframenummer in. Bijvoorbeeld BA5025684 of SP5182259."
        : "Vul een Cortina framenummer of Cortina code in. Bijvoorbeeld CO7392841 of CT7R48LQ2M.";
    return setting(root, "message-invalid-input", fallback);
  }

  function prepareFrameInput(root, input) {
    if (!input) return;
    if (brand(root) === "batavus") {
      input.setAttribute("pattern", "([A-Za-z]{2}[0-9]{7}|BA[A-Za-z0-9]{6,20})");
      input.setAttribute("maxlength", "22");
      var batavusTitle = input.getAttribute("title") || "";
      if (!batavusTitle || /CO|Cortina/i.test(batavusTitle)) {
        input.setAttribute("title", "Gebruik een fietsframenummer zoals BA5025684 of SP5182259.");
      }
      return;
    }
    input.setAttribute("pattern", "(CO[0-9]{6,12}|C[A-Za-z0-9]{5,15})");
    input.setAttribute("maxlength", "16");
    var title = input.getAttribute("title") || "";
    if (!title || title.indexOf("Begint met CO") === 0 || title.indexOf("CO gevolgd door cijfers") !== -1) {
      input.setAttribute(
        "title",
        "Gebruik CO gevolgd door cijfers, of een Cortina code met letters en cijfers zoals CT7R48LQ2M.",
      );
    }
  }

  function appendQuery(url, key, value) {
    var separator = String(url || "").indexOf("?") === -1 ? "?" : "&";
    return String(url || "") + separator + encodeURIComponent(key) + "=" + encodeURIComponent(value);
  }

  function workingTargetPage(value) {
    return value || "/pages/cortina-framenummer-zoeken";
  }

  var VISITOR_KEY = "tps_cortina_visitor_id";
  var LAST_RESULT_KEY = "tps_cortina_last_result_v4";
  var RESULT_CACHE_PREFIX = "tps_cortina_result_v4_";
  var RESULT_CACHE_TTL = 24 * 60 * 60 * 1000;
  var LIVE_VARIANT_ENDPOINT = "/apps/scooter-passing/api/live-variants";
  var CARD_STYLE_ID = "tps-cortina-card-results-style";
  var liveVariantCache = {};
  var liveVariantPending = {};

  function ensureCardStyles() {
    if (document.getElementById(CARD_STYLE_ID)) return;
    var style = document.createElement("style");
    style.id = CARD_STYLE_ID;
    style.textContent =
      '[data-tps-cortina-frame] .tps-cortina-hero{box-sizing:border-box;margin:0 auto 24px;max-width:1202px;}' +
      '[data-tps-cortina-frame] .tps-cortina-category-items{display:grid;gap:14px;grid-template-columns:repeat(auto-fill,minmax(218px,1fr));}' +
      '[data-tps-cortina-frame] .tps-cortina-product-row{align-content:start;background:#fff;border:1px solid #e0e6ee;border-radius:8px;display:grid;gap:0;grid-template-columns:1fr;grid-template-rows:auto minmax(0,1fr) auto;min-height:100%;overflow:hidden;padding:0;transition:border-color .15s ease,box-shadow .15s ease,transform .15s ease;}' +
      '[data-tps-cortina-frame] .tps-cortina-product-row:hover{border-color:#c7d0dc;box-shadow:0 10px 22px rgba(17,24,39,.08);transform:translateY(-1px);}' +
      '[data-tps-cortina-frame] .tps-cortina-product-row.is-no-image{grid-template-columns:1fr;}' +
      '[data-tps-cortina-frame] .tps-cortina-product-image{align-items:center;aspect-ratio:4/3;background:#f7f8fb;border:0;border-bottom:1px solid #edf0f4;border-radius:0;color:var(--tps-muted,#5d6877);display:flex;justify-content:center;min-height:0;overflow:hidden;width:100%;}' +
      '[data-tps-cortina-frame] .tps-cortina-product-image img{height:100%;object-fit:contain;padding:12px;width:100%;}' +
      '[data-tps-cortina-frame] .tps-cortina-product-main{display:flex;flex-direction:column;gap:8px;min-width:0;padding:12px 12px 0;}' +
      '[data-tps-cortina-frame] .tps-cortina-product-title{font-size:14px;line-height:1.35;min-height:38px;}' +
      '[data-tps-cortina-frame] .tps-cortina-product-sku{font-size:12px;line-height:1.35;word-break:break-word;}' +
      '[data-tps-cortina-frame] .tps-cortina-product-side{align-items:stretch;border-top:1px solid #edf0f4;display:flex;flex-direction:column;gap:10px;justify-content:flex-end;margin-top:12px;padding:12px;width:100%;}' +
      '[data-tps-cortina-frame] .tps-cortina-product-price{font-size:18px;line-height:1.1;}' +
      '[data-tps-cortina-frame] .tps-cortina-product-button{align-items:center;display:flex;justify-content:center;min-height:42px;width:100%;}' +
      '[data-tps-cortina-frame] .tps-cortina-stock.is-in-stock{background:#e8fbf1;border-color:#b7efcf;color:#0f7a3c;}' +
      '[data-tps-cortina-frame] .tps-cortina-stock.is-in-stock:before{content:"\\2713";font-weight:800;margin-right:6px;}' +
      '[data-tps-cortina-frame] .tps-cortina-stock.is-out-stock{background:#fff2f2;border-color:#ffd2d2;color:#b42318;}' +
      '[data-tps-cortina-frame] .tps-cortina-stock.is-loading{background:#f6f8fb;border-color:#dce3ec;color:#5d6877;}' +
      '@media(max-width:640px){[data-tps-cortina-frame] .tps-cortina-category-items{grid-template-columns:repeat(auto-fill,minmax(158px,1fr));gap:10px;}[data-tps-cortina-frame] .tps-cortina-product-title{font-size:13px;min-height:36px;}[data-tps-cortina-frame] .tps-cortina-product-price{font-size:16px;}}';
    document.head.appendChild(style);
  }

  function isVisitorId(value) {
    return /^[A-Za-z0-9_-]{20,96}$/.test(String(value || ""));
  }

  function readVisitorCookie() {
    var parts = String(document.cookie || "").split(";");
    for (var index = 0; index < parts.length; index += 1) {
      var part = parts[index].trim();
      if (part.indexOf(VISITOR_KEY + "=") === 0) {
        return decodeURIComponent(part.slice(VISITOR_KEY.length + 1));
      }
    }
    return "";
  }

  function createVisitorId() {
    if (window.crypto && window.crypto.getRandomValues) {
      var bytes = new Uint8Array(18);
      window.crypto.getRandomValues(bytes);
      return Array.prototype.map
        .call(bytes, function (byte) {
          return byte.toString(16).padStart(2, "0");
        })
        .join("");
    }
    return String(Date.now()) + Math.random().toString(36).slice(2) + Math.random().toString(36).slice(2);
  }

  function rememberVisitorId(value) {
    try {
      window.localStorage.setItem(VISITOR_KEY, value);
    } catch (error) {}
    try {
      document.cookie =
        VISITOR_KEY +
        "=" +
        encodeURIComponent(value) +
        "; Max-Age=31536000; Path=/; SameSite=Lax" +
        (window.location.protocol === "https:" ? "; Secure" : "");
    } catch (error) {}
  }

  function visitorId() {
    var value = "";
    try {
      value = window.localStorage.getItem(VISITOR_KEY) || "";
    } catch (error) {}
    if (!isVisitorId(value)) value = readVisitorCookie();
    if (!isVisitorId(value)) value = createVisitorId();
    rememberVisitorId(value);
    return value;
  }

  function lookupUrl(apiUrl, frameNumber) {
    var glue = apiUrl.indexOf("?") === -1 ? "?" : "&";
    return (
      apiUrl +
      glue +
      "framenummer=" +
      encodeURIComponent(frameNumber) +
      "&visitor_id=" +
      encodeURIComponent(visitorId())
    );
  }

  function brandLastResultKey(root) {
    return LAST_RESULT_KEY + "_" + brand(root);
  }

  function resultCacheKey(root, frameNumber) {
    return RESULT_CACHE_PREFIX + brand(root) + "_" + normalizeFrameNumber(frameNumber);
  }

  function parseStoredResult(value) {
    if (!value) return null;
    try {
      var parsed = JSON.parse(value);
      if (!parsed || !parsed.frameNumber || !parsed.data || !parsed.storedAt) return null;
      if (Date.now() - Number(parsed.storedAt) > RESULT_CACHE_TTL) return null;
      return parsed;
    } catch (error) {
      return null;
    }
  }

  function readCachedResult(root, frameNumber) {
    try {
      var key = frameNumber ? resultCacheKey(root, frameNumber) : window.localStorage.getItem(brandLastResultKey(root));
      if (!key) return null;
      var cached = parseStoredResult(window.localStorage.getItem(key));
      if (!cached) {
        if (frameNumber) window.localStorage.removeItem(key);
        return null;
      }
      return cached;
    } catch (error) {
      return null;
    }
  }

  function rememberResult(root, frameNumber, data) {
    var normalized = normalizeFrameNumber(frameNumber);
    if (!isFrameNumber(root, normalized) || !data || !data.validFrameNumber || !data.found) return;
    var articles = storefrontArticles(data);
    if (!articles.length) return;
    try {
      var cachedData = {};
      Object.keys(data).forEach(function (key) {
        cachedData[key] = data[key];
      });
      cachedData.articles = articles;
      cachedData.browserCached = true;
      var key = resultCacheKey(root, normalized);
      window.localStorage.setItem(
        key,
        JSON.stringify({
          frameNumber: normalized,
          storedAt: Date.now(),
          data: cachedData,
        }),
      );
      window.localStorage.setItem(brandLastResultKey(root), key);
    } catch (error) {}
  }

  function updateFrameNumberInUrl(frameNumber) {
    if (!window.history || !window.history.replaceState || !window.URLSearchParams) return;
    try {
      var url = new URL(window.location.href);
      url.searchParams.set("framenummer", normalizeFrameNumber(frameNumber));
      window.history.replaceState(window.history.state, "", url.toString());
    } catch (error) {}
  }

  function setStatus(root, type, message) {
    var node = root.querySelector("[data-tps-cortina-status]");
    if (!node) return;
    node.className = "tps-cortina-status is-visible is-" + (type || "info");
    node.textContent = message || "";
  }

  function clearStatus(root) {
    var node = root.querySelector("[data-tps-cortina-status]");
    if (!node) return;
    node.className = "tps-cortina-status";
    node.textContent = "";
  }

  function clearStatusTimers(root) {
    (root._tpsCortinaStatusTimers || []).forEach(function (timer) {
      window.clearTimeout(timer);
    });
    root._tpsCortinaStatusTimers = [];
  }

  function scheduleStatus(root, delay, type, message) {
    root._tpsCortinaStatusTimers = root._tpsCortinaStatusTimers || [];
    var requestId = root._tpsCortinaRequestId;
    root._tpsCortinaStatusTimers.push(
      window.setTimeout(function () {
        if (root._tpsCortinaRequestId !== requestId) return;
        setStatus(root, type, message);
      }, delay),
    );
  }

  function valueText(value) {
    if (value === true) return "Ja";
    if (value === false) return "Nee";
    if (value == null || value === "") return "-";
    return String(value);
  }

  function formatCents(value) {
    var cents = Number(value || 0);
    if (!Number.isFinite(cents) || cents <= 0) return "";
    return "\u20ac" + (cents / 100).toFixed(2).replace(".", ",");
  }

  function shopifyProduct(article) {
    return article.shopify && article.shopify.found ? article.shopify : {};
  }

  function storefrontArticles(data) {
    return (data.articles || []).filter(function (article) {
      return Boolean(shopifyProduct(article).found);
    });
  }

  function productTitle(article) {
    var product = shopifyProduct(article);
    return product.title || article.naam || article.sku || article.artikelnummer || "Onbekend onderdeel";
  }

  function productUrl(article) {
    var product = shopifyProduct(article);
    if (product.url) return product.url;
    return "#";
  }

  function productHandleFromUrl(url) {
    var match = String(url || "").match(/\/products\/([^/?#]+)/);
    return match ? decodeURIComponent(match[1]) : "";
  }

  function imageUrl(article) {
    var product = shopifyProduct(article);
    return product.imageUrl || article.image_url || article.imageUrl || article.afbeelding || "";
  }

  function priceText(article) {
    var product = shopifyProduct(article);
    var price = product.price || article.prijs || article.price;
    if (!price) return "";
    if (price.text) return String(price.text).replace("\u20ac ", "\u20ac");
    if (price.cents != null) return formatCents(price.cents);
    if (price.amount != null) return "\u20ac" + String(price.amount).replace(".", ",");
    return String(price);
  }

  function stockState(article) {
    var product = shopifyProduct(article);
    if (!product.variantId) return { text: "Bekijk product", className: "is-muted" };
    var qty = product.availableQuantity;
    if (qty != null && Number(qty) > 0) {
      return { text: product.stockLabel || "Op voorraad", className: "is-in-stock" };
    }
    if (product.available === true) return { text: "Op voorraad", className: "is-in-stock" };
    if (qty != null || product.available === false) return { text: "Niet op voorraad", className: "is-out-stock" };
    return { text: "Voorraad laden...", className: "is-loading" };
  }

  function stockStateWithSettings(root, article) {
    var stock = stockState(article);
    if (stock.text === "Op voorraad") stock.text = setting(root, "label-in-stock", stock.text);
    if (stock.text === "Niet op voorraad") stock.text = setting(root, "label-out-stock", stock.text);
    if (stock.text === "Voorraad laden...") stock.text = setting(root, "label-check-stock", stock.text);
    return stock;
  }

  function liveStockState(root, row) {
    if (!row || !row.variantId) return { text: setting(root, "label-check-stock", "Voorraad laden..."), className: "is-loading" };
    if (!row.available) return { text: setting(root, "label-out-stock", "Niet op voorraad"), className: "is-out-stock" };
    return { text: setting(root, "label-in-stock", "Op voorraad"), className: "is-in-stock" };
  }

  function livePriceText(row) {
    var price = row && row.price;
    if (price && price.text) return String(price.text).replace("\u20ac ", "\u20ac");
    if (price && price.cents != null) return formatCents(price.cents);
    return "";
  }

  function applyLiveVariantToRow(root, row, variant) {
    if (!row || !variant) return;
    var stock = row.querySelector("[data-tps-cortina-live-stock]");
    var priceNode = row.querySelector("[data-tps-cortina-live-price]");
    var stockState = liveStockState(root, variant);
    row.classList.toggle("is-unavailable", !variant.available);
    if (stock) {
      stock.classList.remove("is-loading", "is-in-stock", "is-out-stock", "is-muted", "is-orderable");
      stock.classList.add(stockState.className || "is-muted");
      stock.textContent = stockState.text;
    }
    var price = livePriceText(variant);
    if (priceNode && price) {
      priceNode.textContent = price;
      priceNode.classList.remove("tps-cortina-price-muted");
      priceNode.classList.add("tps-cortina-product-price");
    }
    row.setAttribute("data-tps-cortina-live-hydrated", "1");
  }

  function hydrateLiveRows(root) {
    var rows = Array.prototype.slice.call(root.querySelectorAll("[data-tps-cortina-live-card]")).filter(function (row) {
      return row.getAttribute("data-tps-cortina-live-hydrated") !== "1" && row.getAttribute("data-tps-cortina-live-pending") !== "1";
    });
    if (!rows.length) return;
    var ids = [];
    var rowsById = {};
    rows.forEach(function (row) {
      var variantId = row.getAttribute("data-variant-id") || "";
      if (!variantId) return;
      rowsById[variantId] = rowsById[variantId] || [];
      rowsById[variantId].push(row);
      if (liveVariantCache[variantId]) {
        applyLiveVariantToRow(root, row, liveVariantCache[variantId]);
      } else if (!liveVariantPending[variantId]) {
        ids.push(variantId);
      }
    });
    ids = ids.filter(function (id, index) {
      return ids.indexOf(id) === index;
    });
    if (!ids.length) return;
    ids.forEach(function (id) {
      liveVariantPending[id] = true;
      (rowsById[id] || []).forEach(function (row) {
        row.setAttribute("data-tps-cortina-live-pending", "1");
      });
    });
    fetch(LIVE_VARIANT_ENDPOINT + "?ids=" + encodeURIComponent(ids.join(",")), {
      credentials: "same-origin",
      headers: { Accept: "application/json" },
    })
      .then(function (response) {
        if (!response.ok) throw new Error("Live voorraad niet beschikbaar");
        return response.json();
      })
      .then(function (payload) {
        var variants = (payload && payload.variants) || {};
        ids.forEach(function (id) {
          delete liveVariantPending[id];
          var variant = variants[id];
          if (variant) liveVariantCache[id] = variant;
          (rowsById[id] || []).forEach(function (row) {
            row.removeAttribute("data-tps-cortina-live-pending");
            if (variant) applyLiveVariantToRow(root, row, variant);
          });
        });
      })
      .catch(function () {
        ids.forEach(function (id) {
          delete liveVariantPending[id];
          (rowsById[id] || []).forEach(function (row) {
            row.removeAttribute("data-tps-cortina-live-pending");
          });
        });
      });
  }

  function articleImage(root, article, title) {
    var src = imageUrl(article);
    if (src) {
      return (
        '<img src="' +
        escapeHtml(src) +
        '" alt="' +
        escapeHtml(title) +
        '" loading="lazy">'
      );
    }
    return '<span class="tps-cortina-image-placeholder">' + escapeHtml(setting(root, "label-no-image", "Geen afbeelding")) + "</span>";
  }

  function uniqueCategories(articles) {
    var seen = {};
    var out = [];
    articles.forEach(function (article) {
      var category = article.categorie || "Overig";
      if (seen[category]) return;
      seen[category] = true;
      out.push(category);
    });
    return out.sort(function (a, b) {
      return a.localeCompare(b, "nl");
    });
  }

  function groupedArticles(articles) {
    return uniqueCategories(articles).map(function (category) {
      return {
        category: category,
        articles: articles.filter(function (article) {
          return (article.categorie || "Overig") === category;
        }),
      };
    });
  }

  function articleCard(root, article) {
    var product = shopifyProduct(article);
    var sku = product.sku || article.shopifySku || article.shopify_sku || article.sku || article.artikelnummer || "";
    var title = productTitle(article);
    var price = priceText(article);
    var stock = stockStateWithSettings(root, article);
    var mounted = article.aantal_gemonteerd ? article.aantal_gemonteerd + "x gemonteerd" : "";
    var url = productUrl(article);
    var variantId = product.variantId || "";
    var handle = product.handle || productHandleFromUrl(url);
    var showImage = enabled(root, "show-product-images", true);
    var showSku = enabled(root, "show-sku", true);
    var showMounted = enabled(root, "show-mounted", true);
    var showStock = enabled(root, "show-stock", true);
    var showPrice = enabled(root, "show-price", true);
    var showButton = enabled(root, "show-product-button", true);
    return (
      '<article class="tps-cortina-product-row' +
      (showImage ? "" : " is-no-image") +
      '" data-tps-cortina-live-card data-variant-id="' +
      escapeHtml(variantId) +
      '" data-product-handle="' +
      escapeHtml(handle) +
      '">' +
      (showImage
        ? '<a class="tps-cortina-product-image" href="' +
          escapeHtml(url) +
          '">' +
          articleImage(root, article, title) +
          "</a>"
        : "") +
      '<div class="tps-cortina-product-main">' +
      (showMounted && mounted ? '<div class="tps-cortina-product-kicker">' + escapeHtml(mounted) + "</div>" : "") +
      '<a class="tps-cortina-product-title" href="' +
      escapeHtml(url) +
      '">' +
      escapeHtml(title) +
      "</a>" +
      (showSku
        ? '<div class="tps-cortina-product-sku">' +
          escapeHtml(setting(root, "label-sku", "Artikelnummer")) +
          ': <strong>' +
          escapeHtml(sku || "-") +
          "</strong></div>"
        : "") +
      (showStock
        ? '<div class="tps-cortina-product-tags">' +
          '<span class="tps-cortina-stock ' +
          stock.className +
          '" data-tps-cortina-live-stock' +
          (variantId ? ' aria-live="polite"' : "") +
          '">' +
          escapeHtml(stock.text) +
          "</span>" +
          "</div>"
        : "") +
      "</div>" +
      '<div class="tps-cortina-product-side">' +
      (showPrice
        ? price
          ? '<strong class="tps-cortina-product-price" data-tps-cortina-live-price>' + escapeHtml(price) + "</strong>"
          : '<span class="tps-cortina-price-muted" data-tps-cortina-live-price>' + escapeHtml(setting(root, "label-view-price", "Bekijk prijs")) + "</span>"
        : "") +
      (showButton
        ? '<a class="tps-cortina-product-button" href="' +
          escapeHtml(url) +
          '">' +
          escapeHtml(setting(root, "label-product-button", "Bekijk product")) +
          "</a>"
        : "") +
      "</div>" +
      "</article>"
    );
  }

  function categoryBlock(root, group) {
    return (
      '<section class="tps-cortina-category-block">' +
      '<header class="tps-cortina-category-header">' +
      "<h2>" +
      escapeHtml(group.category) +
      "</h2>" +
      (enabled(root, "show-category-count", true)
        ? '<span class="tps-cortina-category-count">' +
          escapeHtml(String(group.articles.length)) +
          (group.articles.length === 1
            ? " " + setting(root, "label-single-article", "artikel")
            : " " + setting(root, "label-multiple-articles", "artikelen")) +
          "</span>"
        : "") +
      "</header>" +
      '<div class="tps-cortina-category-items">' +
      group.articles
        .map(function (article) {
          return articleCard(root, article);
        })
        .join("") +
      "</div>" +
      "</section>"
    );
  }

  function bicycleDetails(data) {
    var details = data && (data.parentProduct || data.parent_product);
    return details && typeof details === "object" ? details : {};
  }

  function publicSpec(spec) {
    var label = String((spec && spec.label) || "").trim();
    var value = String((spec && spec.value) || "").trim();
    if (!label || !value) return null;
    if (/artikelnummer|article|ean|prijs|price|consumentenprijs|uw prijs|bruto|netto/i.test(label)) return null;
    return { label: label, value: value };
  }

  function renderBicycleInfo(data) {
    var details = bicycleDetails(data);
    var title = details.title || "";
    var subtitle = details.subtitle || "";
    var description = details.description || "";
    var specs = Array.isArray(details.specifications)
      ? details.specifications
          .map(publicSpec)
          .filter(Boolean)
          .slice(0, 24)
      : [];
    if (!title && !subtitle && !description && !specs.length) return "";
    return (
      '<section class="tps-cortina-bike-info" aria-label="Fietsinformatie">' +
      (title ? '<h2>' + escapeHtml(title) + "</h2>" : "") +
      (subtitle ? '<p class="tps-cortina-bike-subtitle">' + escapeHtml(subtitle) + "</p>" : "") +
      (description ? '<p class="tps-cortina-bike-description">' + escapeHtml(description) + "</p>" : "") +
      (specs.length
        ? '<dl class="tps-cortina-bike-specs">' +
          specs
            .map(function (spec) {
              return "<div><dt>" + escapeHtml(spec.label) + "</dt><dd>" + escapeHtml(spec.value) + "</dd></div>";
            })
            .join("") +
          "</dl>"
        : "") +
      "</section>"
    );
  }

  function renderArticles(root, data) {
    var node = root.querySelector("[data-tps-cortina-articles]");
    if (!node) return;
    var articles = storefrontArticles(data);
    var groups = groupedArticles(articles);
    if (!articles.length) {
      node.innerHTML = '<p class="tps-cortina-note">' + escapeHtml(setting(root, "message-no-webshop-products", "Geen onderdelen gevonden die momenteel in de webshop staan.")) + "</p>";
      return;
    }
    if (!enabled(root, "group-categories", true)) {
      node.innerHTML =
        '<section class="tps-cortina-category-block is-ungrouped"><div class="tps-cortina-category-items">' +
        articles
          .map(function (article) {
            return articleCard(root, article);
          })
          .join("") +
        "</div></section>";
      hydrateLiveRows(root);
      return;
    }
    node.innerHTML = groups
      .map(function (group) {
        return categoryBlock(root, group);
      })
      .join("");
    hydrateLiveRows(root);
  }

  function renderResult(root, data) {
    var node = root.querySelector("[data-tps-cortina-results]");
    if (!node) return;
    var articles = storefrontArticles(data);

    if (!data.validFrameNumber) {
      node.innerHTML = "";
      setStatus(root, "error", data.message || setting(root, "message-invalid-response", "Geen geldig framenummer gevonden."));
      return;
    }

    if (!data.found) {
      node.innerHTML = "";
      setStatus(root, "info", data.message || setting(root, "message-not-found", "Framenummer gevonden, maar geen onderdelen beschikbaar."));
      return;
    }

    if (!articles.length) {
      node.innerHTML = "";
      setStatus(root, "info", setting(root, "message-no-webshop-products", "Voor dit framenummer zijn geen onderdelen gevonden die momenteel in de webshop staan."));
      return;
    }

    clearStatus(root);
    var resultNote = root.getAttribute("data-result-note") || "";
    node.innerHTML =
      renderBicycleInfo(data) +
      '<section class="tps-cortina-list" data-tps-cortina-articles></section>' +
      (resultNote && enabled(root, "show-result-note", true) ? '<p class="tps-cortina-note">' + escapeHtml(resultNote) + "</p>" : "");

    renderArticles(root, data);
  }

  function setLoading(root, loading, text) {
    var button = root.querySelector("[data-tps-cortina-submit]");
    var form = root.querySelector("[data-tps-cortina-form]");
    root.classList.toggle("is-loading", Boolean(loading));
    if (form) form.classList.toggle("is-loading", Boolean(loading));
    if (!button) return;
    if (!button.getAttribute("data-default-label")) {
      button.setAttribute("data-default-label", button.textContent || "Zoek onderdelen");
    }
    button.disabled = loading;
    button.setAttribute("aria-busy", loading ? "true" : "false");
    button.textContent = loading ? text || "Bezig met zoeken..." : button.getAttribute("data-default-label");
  }

  function initRoot(root) {
    if (root.getAttribute("data-ready") === "1") return;
    root.setAttribute("data-ready", "1");
    ensureCardStyles();

    var form = root.querySelector("[data-tps-cortina-form]");
    if (!form) return;

    var input = root.querySelector("[data-tps-cortina-input]");
    prepareFrameInput(root, input);
    var apiUrl =
      root.getAttribute("data-api-url") ||
      (brand(root) === "batavus" ? "/apps/scooter-passing/api/batavus-spareparts" : "/apps/scooter-passing/api/cortina-spareparts");
    var targetPage = workingTargetPage(
      root.getAttribute("data-target-page") ||
        (brand(root) === "batavus" ? "/pages/batavus-framenummer" : "/pages/cortina-framenummer-zoeken"),
    );
    var isHomeStrip = root.classList.contains("tps-cortina-strip");

    form.addEventListener("submit", function (event) {
      event.preventDefault();
      var frameNumber = normalizeFrameNumber(input && input.value);
      if (input) input.value = frameNumber;
      if (!frameNumber) {
        setStatus(root, "error", setting(root, "message-empty-input", brand(root) === "batavus" ? "Vul een Batavus framenummer in." : "Vul een Cortina framenummer in."));
        return;
      }
      if (!isFrameNumber(root, frameNumber)) {
        setStatus(root, "error", cortinaFormatMessage(root));
        return;
      }

      if (isHomeStrip) {
        setLoading(root, true, setting(root, "message-opening", "Openen..."));
        window.location.href = appendQuery(targetPage, "framenummer", frameNumber);
        return;
      }

      updateFrameNumberInUrl(frameNumber);
      var cached = readCachedResult(root, frameNumber);
      if (cached) {
        root._tpsCortinaData = cached.data;
        renderResult(root, cached.data);
        return;
      }

      root._tpsCortinaRequestId = (root._tpsCortinaRequestId || 0) + 1;
      var requestId = root._tpsCortinaRequestId;
      clearStatusTimers(root);
      setLoading(root, true, setting(root, "message-button-loading", "Bezig met zoeken..."));
      setStatus(root, "loading", setting(root, "message-loading", "Bezig met zoeken..."));
      scheduleStatus(root, 900, "loading", "Fiets zoeken...");
      scheduleStatus(root, 2200, "loading", "Onderdelen laden...");
      var results = root.querySelector("[data-tps-cortina-results]");
      if (results) results.innerHTML = "";

      function runLookupPoll(attempt) {
        root._tpsCortinaProcessing = false;
        var url = lookupUrl(apiUrl, frameNumber);
        if (attempt) url += (url.indexOf("?") === -1 ? "?" : "&") + "poll=1";
        fetch(url, {
          credentials: "same-origin",
          headers: { accept: "application/json" },
        })
          .then(function (response) {
            return response.text().then(function (text) {
              var data = null;
              try {
                data = JSON.parse(text);
              } catch (error) {
                data = null;
              }
              if (!response.ok || !data) {
                var fallback =
                  response.status === 404
                    ? setting(root, "message-service-no-answer", "De zoekservice gaf geen antwoord via Shopify. Probeer het opnieuw.")
                    : setting(root, "message-search-failed", "Zoeken lukte niet. Probeer het later opnieuw.");
                var message = data && data.message ? data.message : fallback;
                throw Object.assign(new Error(message), { data: data, status: response.status });
              }
              return data;
            });
          })
          .then(function (data) {
            if (root._tpsCortinaRequestId !== requestId) return;
            if (data && data.processing) {
              root._tpsCortinaProcessing = true;
              clearStatusTimers(root);
              setLoading(root, true, data.message || "Onderdelen laden...");
              setStatus(root, "loading", data.message || "Onderdelen laden...");
              window.setTimeout(function () {
                if (root._tpsCortinaRequestId !== requestId) return;
                runLookupPoll(attempt + 1);
              }, Math.max(1200, Math.min(5000, Number(data.retryAfterMs) || 2000)));
              return;
            }
            clearStatusTimers(root);
            root._tpsCortinaData = data;
            rememberResult(root, frameNumber, data);
            if (data && data.validFrameNumber && data.found) {
              setStatus(root, "loading", "Fiets gevonden. Onderdelen laden...");
              window.setTimeout(function () {
                if (root._tpsCortinaRequestId !== requestId) return;
                renderResult(root, data);
              }, 300);
            } else {
              renderResult(root, data);
            }
          })
          .catch(function (error) {
            if (root._tpsCortinaRequestId !== requestId) return;
            clearStatusTimers(root);
            root._tpsCortinaData = null;
            setStatus(root, error.status === 429 ? "info" : "error", error.message || "Zoeken mislukt.");
          })
          .finally(function () {
            if (root._tpsCortinaRequestId !== requestId) return;
            clearStatusTimers(root);
            if (!root._tpsCortinaProcessing) setLoading(root, false);
          });
      }

      runLookupPoll(0);
    });

    if (!isHomeStrip && input && window.URLSearchParams) {
      var params = new URLSearchParams(window.location.search || "");
      var frameFromUrl = normalizeFrameNumber(
        params.get("framenummer") || params.get("frame_number") || params.get("frameNumber") || params.get("search"),
      );
      if (isFrameNumber(root, frameFromUrl) && root.getAttribute("data-url-autosearch") !== "1") {
        root.setAttribute("data-url-autosearch", "1");
        input.value = frameFromUrl;
        var cachedFromUrl = readCachedResult(root, frameFromUrl);
        if (cachedFromUrl) {
          root._tpsCortinaData = cachedFromUrl.data;
          renderResult(root, cachedFromUrl.data);
        } else {
          window.setTimeout(function () {
            form.dispatchEvent(new Event("submit", { bubbles: true, cancelable: true }));
          }, 60);
        }
      } else if (!frameFromUrl) {
        var lastCached = readCachedResult(root, "");
        if (lastCached && isFrameNumber(root, lastCached.frameNumber)) {
          input.value = lastCached.frameNumber;
          root._tpsCortinaData = lastCached.data;
          renderResult(root, lastCached.data);
        }
      }
    }
  }

  function ready() {
    document.querySelectorAll("[data-tps-cortina-frame]").forEach(initRoot);
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", ready);
  else ready();
})();
